<template>
  <div class="c-content-three-column" :class="{ padding: fields?.padding?.value === true }">
    <div class="column">
      <sc-placeholder name="jss-content-three-column-left" :rendering="rendering" />
    </div>
    <div class="column">
      <sc-placeholder name="jss-content-three-column-middle" :rendering="rendering" />
    </div>
    <div class="column">
      <sc-placeholder name="jss-content-three-column-right" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Content-Three-Column',
  components: {
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.c-content-three-column {
  @include margin-y(2rem);
  @include padding-x-thin;
  padding-left: 0;
  padding-right: 0;

  @include desktop-up {
    display: flex;
    flex-direction: row;
    @include margin-y(2rem, 4rem);
    padding-left: 0;
    padding-right: 0;
  }

  &.padding {
    @include padding-x(2rem);

    @include desktop-up {
      @include padding-x(7rem);
    }
  }

  .column {
    margin-bottom: 4rem;

    @include desktop-up {
      width: calc(100% / 3);
      padding: 1.5rem;
      margin-bottom: 0;
    }

    &:first-child {
      @include desktop-up {
        padding-left: 0;
      }
    }

    &:last-child {
      @include desktop-up {
        padding-right: 0;
      }
    }

    &:deep() {
      a[class^='c-cta'] {
        @include desktop-down {
          padding-bottom: 0;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
